export default "__VITE_ASSET___1X0BJcl__"